const { DateTime, Duration } = require('luxon');


function timeGridFormattedDate(date) {
    return date.toFormat('ccc, LLL dd');
}

function pruneTimezoneFromString(dateString) {
    // IF the string has a Z on the end, or has a + in it, then we need to prune it.
    const tempString = dateString.includes("Z") ? dateString.split("Z")[0] : dateString;
    const resultString = tempString.includes("+") ? tempString.split("+")[0] : tempString;
    return resultString;
}

// Assumes date is a luxon DateTime object.
function addDays(date, days) {
    const dur = Duration.fromObject({ days: days });
    return date.plus(dur);
}

function timeGridFormatDateStringForSlot(dateTime, timezone) {
    const date = parseStringWithTimezone(dateTime, timezone);
    const day = timeGridFormattedDate(date);
    const hour = date.hour;
    const period = hour < 12 ? 'am' : 'pm';
    const formattedHour = hour <= 12 ? hour : hour - 12;
    const formattedMinutes = date.minute === 0 ? '00' : date.minute < 10 ? `0${date.minute}` : date.minute;
    const time = `${formattedHour}:${formattedMinutes} ${period}`;
    return `${day}-${time}`;
}

function timeGridGetDateTimeFromDateAndString(dateAsDateTime, timeString) {

    // "${formattedHour}:00 ${period}"
    const [hours, minutesPart] = timeString.split(':');
    const minutes = minutesPart.substring(0, 2);
    const period = minutesPart.substring(3);
    const slotHours = period === 'pm' && hours !== '12' ? parseInt(hours, 10) + 12 : hours === '12' && period === 'am' ? 0 : parseInt(hours, 10);
    Duration.fromObject({ hours: slotHours, minutes: minutes })
    return dateAsDateTime.plus({ hours: slotHours, minutes: minutes });
}

function timeGridGetDateTimeFromTimeGridString(timeGridString) {
    const [day, time] = timeGridString.split('-');
    const date = DateTime.fromFormat(day, 'ccc, LLL d');
    // Next, handle the time. It's in the format of "12:00 am" or "12:00 pm"
    const [hours, minutesPart] = time.trim().split(':');
    const minutes = minutesPart.substring(0, 2);
    const period = minutesPart.substring(3).toLowerCase();
    const slotHours = period === 'pm' && hours !== '12' ? parseInt(hours, 10) + 12 :
        hours === '12' && period === 'am' ? 0 :
            parseInt(hours, 10);

    return date.plus({ hours: slotHours, minutes: parseInt(minutes, 10) });
}

// function parseStringToTimezoneNoTimeAdjustments(dateString, timezone) {
//     return DateTime.fromISO(pruneTimezoneFromString(dateString), { zone: timezone });
// }

function parseStringWithTimezone(dateString, timezone) {
    return DateTime.fromISO(dateString, { zone: timezone });
}

function parseISOStringToReadableDateAndTime(dateString, timezone) {
    if (!dateString) {
        return ["", ""];
    }
    const dateTime = DateTime.fromISO(dateString, { zone: timezone });
    const formattedDate = dateTime.toFormat('cccc, LLL d');
    const formattedTime = dateTime.toFormat('h:mm a');

    return [formattedDate, formattedTime]
}

function parseISOStringToLongDate(dateString, timezone) {
    const dateTime = DateTime.fromISO(dateString, { zone: timezone });
    return dateTime.toFormat('ccc, LLL d, yyyy');
}

function timeInFutureFromISOString(dateString) {
    const dateTime = DateTime.fromISO(dateString);
    return dateTime > DateTime.now();
}

function getMostRecentSunday() {
    const today = DateTime.now();
    const dayOfWeek = today.weekday;
    return today.minus({ days: dayOfWeek });
}

function getMostRecentSundayInTimezone(timezone) {
    const today = DateTime.now().setZone(timezone);
    const dayOfWeek = today.weekday % 7; // 7 is Sunday, so don't go back a week.
    return today.minus({ days: dayOfWeek });

}

// Take a timestamp in UTC and return the number of days ago it was.
function daysAgo(timeStamp) {
    const dateTime = DateTime.fromISO(timeStamp);
    const now = DateTime.now();
    const diff = now.diff(dateTime, 'days');
    return diff.days;

}

export default {
    timeGridFormatDateStringForSlot,
    timeGridGetDateTimeFromDateAndString,
    timeGridGetDateTimeFromTimeGridString,
    // parseStringToTimezoneNoTimeAdjustments,
    parseStringWithTimezone,
    addDays,
    timeGridFormattedDate,
    parseISOStringToReadableDateAndTime,
    parseISOStringToLongDate,
    timeInFutureFromISOString,
    getMostRecentSunday,
    getMostRecentSundayInTimezone,
    daysAgo,

}